/**
 * Shared types for SignUp modal components to break circular dependencies
 */

// Define types that need to be shared between components that might have circular dependencies
export enum SignUpModalScreenName {
  SignUpAllPlans = 'sign-up-all-plans',
  SignUpFree = 'sign-up-free',
  SignUpEssentials = 'sign-up-essentials',
  SignUpCreator = 'sign-up-creator',
  SignUpPro = 'sign-up-pro',
  SignUpBusiness = 'sign-up-business',
}
